import { useEffect, useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import {
  Container,
  Content,
  InfoContainerStatus,
  InfoContainerText,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionList,
  SubscriptionTitle,
} from "../../profile/subscriptions/styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Loading from "../../../components/atoms/loading";
import React from "react";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useParams } from "react-router-dom";
import { StringToSlug, StringToSlugPraia } from "../../../utils/SlugConverter";
import { TournamentLink } from "src/pages/tournament/styles";
import { FormContent } from "src/pages/auth/change-password/styles";
import { useForm } from "react-hook-form";
import { FormGroup } from "../../../pages/auth/login/styles";
import Input from "../../../components/atoms/input";
import BasicModal from "src/components/organisms/tournamentBracket/modal";
import { Box, Button, Fab, Typography, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Swal from "sweetalert2";
import { HistoryModal } from "src/components/atoms/historyModal";
import HistoryIcon from '@mui/icons-material/History';

const AllCheckCategoriesICopaBjjTalentDeJiuJitsu2026 = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  let password = {
    torneio: "bjjtalent@2026",
    credenciais: {
      usuario: "bjjtalent@2026",
      senha: "bjjtalent@2026",
    },
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getToken, account } = useAuthenticate();


  const [dataTratada, setDataTratada] = useState<
  { category: string; figthers: any; order: number }[]
>([]);




  const [showData, setShowData] = useState(false);
  const url = window.location.pathname;
  const { slug } = useParams();
  const [tournament, setTournament] = useState<any>({});
  const [subscription, setSubscription] = useState<any>([]);
  const [senha, setSenha] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();
  const [manager, setManager] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const [genderFilter, setGenderFilter] = useState<"all" | "masculino" | "feminino">("all");

  const filterByGender = (data: any[]) => {
    if (genderFilter === "all") return data;
    return data.filter(
      (value) => value.genre?.toLowerCase() === genderFilter
    );
  };

  const handleCheckPassword = (data: any) => {
    if (data.password === password.credenciais.senha) {
      setIsAuthorized(true);
    } else {
      alert("Senha incorreta");
    }
  };

  const getFirstCategoryPart = (title: string) => {
  const t = (title ?? "").toString().trim();

  const beforeSlash = t.split("/")[0].trim();
  const beforeSemicolon = beforeSlash.split(";")[0].trim();
  const beforeDashSpaces = beforeSemicolon.split(" - ")[0].trim();

  return beforeDashSpaces;
};

  const handleEditFighter = (fighterId: number) => {

    if (manager) {
      Swal.fire({
        title: "Como deseja editar sua inscrição?",
        text: "Você pode editar seguindo as regras do evento ou livremente.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: '#373737',
        confirmButtonText: "Editar com regras",
        denyButtonText: "Editar sem regras",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'regras' } });
        else if (result.isDenied) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'livre' } });
      });
    } else {
      navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url } });
    }

  }

  const showHistorySubsModal = async (subscriptionId: number) => {

    await api.get(`/history/Subscription/${subscriptionId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    ).then(res => {
      setHistoryData(res.data);
      setIsModalOpen(true);
    })

  }

  const normalize = (v: unknown) =>
    (v ?? "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s*-\s*/g, "-")
      .replace(/\s+/g, " ");

  console.log(normalize('MÉDIO1'))

  const normalizeCategory = (cat: unknown) => {
    const n = normalize(cat);
    if (!n) return n;
    const parts = n.split("-").map(p => p.trim());
    return parts[parts.length - 1] || n;
  };

  const getOrder = <T extends string>(
    map: Record<string, number>,
    key: unknown,
    fallback = 999
  ) => map[normalize(key as string)] ?? fallback;

  const baseCategory = (raw: unknown) => {
    const n = normalize(raw);
    if (!n) return n;

    if (/\s[-–—]\s/.test(n)) {
      const parts = n.split(/\s[-–—]\s/);
      return parts[parts.length - 1] || n;
    }

    return n;
  };

  const beltOrderSafe = (beltRaw: unknown, beltMap: Record<string, number>) => {
    const b = normalize(beltRaw);
    if (!b) return 999;

    if (b in beltMap) return beltMap[b];

    if (b.includes(" e ")) {
      const parts = b.split(" e ").map(x => x.trim());
      const nums = parts.map(p => beltMap[p] ?? 999);
      return Math.min(...nums);
    }

    return beltMap[b] ?? 999;
  };

  const weightOrderSafe = (wRaw: unknown, wMap: Record<string, number>) =>
    wMap[normalize(wRaw)];

  const genderOrderMap: Record<string, number> = {
    "feminino": 1,
    "masculino": 2,
  };

  const genderOrderSafe = (gRaw: unknown) =>
    genderOrderMap[normalize(gRaw)] ?? 99;

  const parseTitle = (title: string) => {
    const [cat, gen, belt, weight] = title.split("/");
    return {
      catRaw: cat ?? "",
      genRaw: gen ?? "",
      beltRaw: belt ?? "",
      weightRaw: weight ?? "",
      catBase: baseCategory(cat),
    };
  };

  const isParaOrPCD = (catRaw: unknown) => {
    const c = normalize(catRaw);
    return c.startsWith("pcd") || c.startsWith("parajiu");
  };

  const categoryOrder: { [key: string]: number } = {
    "luta casada; pre-mirim": 1,
    "luta casada; mirim a": 2,
    "luta casada; mirim b": 3,
    "luta casada; infantil a": 4,
    "luta casada; infantil b": 5,
    "luta casada; infanto juvenil": 6,
    "luta casada; juvenil": 7,
    "luta casada; adulto": 8,
    "luta casada; master 1 e 2": 9,
    "luta casada; master 3, 4 e 5": 10,
  };

  const beltOrder: { [key: string]: number } = {
    branca: 1,
    graduado: 2,
    cinza: 3,
    amarela: 4,
    laranja: 5,
    verde: 6,
    'laranja e verde': 7,
    azul: 8,
    roxa: 9,
    marrom: 10,
    preta: 11,
  };

  const weightOrder: { [key: string]: number } = {
    "casamento manual": 1,
    galo: 2,
    pluma: 3,
    "pena": 4,
    "leve": 5,
    medio: 6,
    "meio pesado": 7,
    pesado: 8,
    "super pesado": 9,
    pesadíssimo: 10,
    absoluto: 11,
  };

  interface User {
    id: number;
    name: string;
    phone: string;
    email: string;
    gym: string;
    genre: string;
  }

  interface Fighter {
    id: number;
    weight: string;
    genre: string;
    age: string;
    belt: string;
    category: string;
    valueSubscription: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    userId: number;
    fightersId: number | null;
    tournamentId: number;
    fighters: any;
    user: User;
  }

  const reorganizeCategories = (categories: Record<string, any[]>) => {
    const result: Record<string, any[]> = {};

    Object.entries(categories).forEach(([title, data]) => {
      if (data.length <= 2) {
        result[title] = data;
      } else {
        const isEven = data.length % 2 === 0;

        if (isEven) {
          result[title] = data.slice(0, 2);

          let counter = 1;
          for (let i = 2; i < data.length; i += 2) {
            const group = data.slice(i, i + 2);
            result[`${title}${counter}`] = group;
            counter++;
          }
        } else {
          result[title] = data.slice(0, 1);

          let counter = 1;
          for (let i = 1; i < data.length; i += 2) {
            const group = data.slice(i, i + 2);
            result[`${title}${counter}`] = group;
            counter++;
          }
        }
      }
    });

    return result;
  };

  const parseWeightOrder = (peso: string): number => {
    const lower = peso.toLowerCase().trim();

    const match = lower.match(/^([a-z\sç]+?)(\d+)?$/i);

    if (match) {
      const base = match[1].trim();
      const num = match[2] ? Number(match[2]) : 0;

      const baseOrder = weightOrder[base] ?? 999;

      return baseOrder + num * 0.01;
    }

    return 999;
  };


  function converterSubscriptions(array: any) {
    const subscriptions: {
      id: any;
      weight: any;
      age: any;
      gender: any;
      genderBool: string;
      belt: any;
      category: any;
      name: any;
      gymAbre: any;
      gym: any;
      status: any;
      value: any;
      categoryw: any;
    }[] = [];
    array.forEach((item: any) => {
      let fighterBelt = item.belt;
      if (item.belt === "laranja" || item.belt === "verde") {
        fighterBelt = "graduado";
      }
      if (item.belt === "cinza" || item.belt === "amarela") {
        fighterBelt = "graduado";
      }

      let category;

      category = StringToSlug(
        `${fighterBelt}/${item.genre}/${item.weight}/${item.category}`
      );

      if (item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.fighters.genre,
          genderBool:
            item.fighters.genre === "Masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.fighters.name,
          gymAbre: item.fighters.gym.substring(0, 12),
          gym: item.fighters.gym,
          status: item.status,
          categoryw: category,
          value: item.valueSubscription,
        });
      }

      if (!item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.user.genre,
          genderBool: item.user.genre === "masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.user.name,
          gymAbre: item.user.gym.substring(0, 12),
          gym: item.user.gym,
          status: item.status,
          categoryw: category,
          value: item.valueSubscription,
        });
      }
    });

    function categorizeParticipants(participants: any) {
      let categories: any = {};

      participants.forEach((participant: any) => {
        let fighterBelt = participant.belt;
        if (participant.belt === "laranja" || participant.belt === "verde") {
          fighterBelt = "graduado";
        }
        if (participant.belt === "cinza" || participant.belt === "amarela") {
          fighterBelt = "graduado";
        }

        const categoryIdentifier = `${participant.category.toLowerCase()}/${participant.genre.toLowerCase()}/${fighterBelt.toLowerCase()}/${participant.weight?.split(';')[1].toUpperCase()?.trim()}`;

        if (!categories[categoryIdentifier]) {
          categories[categoryIdentifier] = [];
        }

        categories[categoryIdentifier].push(participant);
      });


      const categoriesOrganized = reorganizeCategories(categories);

      let testeLucas = Object.keys(categoriesOrganized).map((title) => {
        const { weightRaw } = parseTitle(title);

        console.log(`${weightRaw} -- ordem= ` + parseWeightOrder(normalize(weightRaw)))

        return {
          title,
          weightOrderVal: parseWeightOrder(weightRaw),
        };
      });

      let categoriesArray = Object.keys(categoriesOrganized).map((title) => {
        const { catRaw, genRaw, beltRaw, weightRaw, catBase } = parseTitle(title);

        return {
          title,
          data: categoriesOrganized[title],
          prefixOrderVal: isParaOrPCD(catRaw) ? 1 : 0,

          categoryOrderVal: categoryOrder[catBase] ?? 999,
          genderOrderVal: genderOrderSafe(genRaw),
          beltOrderVal: beltOrderSafe(beltRaw, beltOrder),
          weightOrderVal: parseWeightOrder(normalize(weightRaw)),
        };
      });

      categoriesArray.sort((a, b) => {
        if (a.prefixOrderVal !== b.prefixOrderVal) {
          return a.prefixOrderVal - b.prefixOrderVal;
        }
        if (a.categoryOrderVal !== b.categoryOrderVal) {
          return a.categoryOrderVal - b.categoryOrderVal;
        }
        if (a.genderOrderVal !== b.genderOrderVal) {
          return a.genderOrderVal - b.genderOrderVal;
        }
        if (a.beltOrderVal !== b.beltOrderVal) {
          return a.beltOrderVal - b.beltOrderVal;
        }
        return a.weightOrderVal - b.weightOrderVal;
      });

      console.log(categoriesArray);

      setSubscription(categoriesArray);

      const dataTratadaArr: { category: string; figthers: any; order: number }[] = [];

categoriesArray.forEach((category: any, idx: number) => {
  const order = idx + 1;

  const baseName = getFirstCategoryPart(category.title);
  const categoryNameToSend = `${baseName} -${order}`;

  dataTratadaArr.push({
    category: categoryNameToSend,
    order,
    figthers: category.data.map((item: any) => {
      if (item.fighters == null) {
        return {
          name: item.user.name,
          gym: item.user.gym,
          belt: item.belt,
          weight: item.weight,
        };
      } else {
        return {
          name: item.fighters.name,
          gym: item.fighters.gym,
          belt: item.belt,
          weight: item.weight,
        };
      }
    }),
  });
});



      setDataTratada(dataTratadaArr);
    }

    categorizeParticipants(array);
  }

  useEffect(() => {
    if (account?.roles?.includes('manager') || tournament.authorId === account.id) {
      setManager(true);
    } else {
      setManager(false);
    }
  }, [account]);

  useEffect(() => {
    setLoading(true);

    api
      .get("/tournaments/" + slug)
      .then(({ data }) => {
        setTournament(data);
      })
      .catch(() => {
        toast.error("Não foi carregar os dados do torneio.");
      });

    api
      .get("/tournaments/enrollments/list-all/public/" + slug, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);

        const sortedArray = data
          .filter((item: Fighter) => item.status === true)
          .slice()
          .sort((a: Fighter, b: Fighter) => {
            const aGenre = normalize(a.genre);
            const bGenre = normalize(b.genre);

            if (aGenre !== bGenre) {
              if (aGenre === "feminino") return -1;
              if (bGenre === "feminino") return 1;
            }

            const aCat = normalizeCategory(a.category);
            const bCat = normalizeCategory(b.category);
            const catDiff = getOrder(categoryOrder, aCat) - getOrder(categoryOrder, bCat);
            if (catDiff !== 0) return catDiff;

            const beltDiff = beltOrderSafe(a.belt, beltOrder) - beltOrderSafe(b.belt, beltOrder);
            if (beltDiff !== 0) return beltDiff;

            const weightDiff = getOrder(weightOrder, a.weight) - getOrder(weightOrder, b.weight);
            if (weightDiff !== 0) return weightDiff;

            const aName = normalize(a.user?.name);
            const bName = normalize(b.user?.name);
            return aName.localeCompare(bName);
          });

        setData(sortedArray);

        if (data && subscription.length === 0)
          converterSubscriptions(sortedArray);

        setShowData(true);
      })
      .catch((err) => {
        console.log(err)
        setLoading(false);
        toast.error("Não foi carregar os dados das inscrições.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) return <Loading text="Aguarde, estamos processando os dados." />;

  let quantidadeInscrcaoPagas = data.length;
  let quatidadeDeChaves = subscription.filter(
    (item: any) => item.data.length > 0
  ).length;
  let quatidadeDeChavesSemLuta = subscription.filter(
    (item: any) => item.data.length === 1
  ).length;

  let medalhasBronze = subscription.filter(
    (item: any) => item.data.length > 2
  ).length;
  let medalhasPrata =
    medalhasBronze +
    subscription.filter((item: any) => item.data.length === 2).length;
  let medalhasOuro =
    medalhasPrata +
    subscription.filter((item: any) => item.data.length === 1).length;


  return (
    <>
      <NavBar />
      <Container>
        <Content id="todaslutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "2.0rem",
                fontFamily: "inter, sans-serif",
                fontWeight: 400,
              }}
            >
              CHECAGEM {tournament.name}
            </Typography>

            <Typography
              sx={{
                color: "red",
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
              }}
            >
              Somente inscrições pagas aparecem na checagem
            </Typography>

            {/* Filtro de gênero */}
            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              <Button
                variant={genderFilter === "all" ? "contained" : "outlined"}
                onClick={() => setGenderFilter("all")}
              >
                Todas
              </Button>
              <Button
                variant={
                  genderFilter === "masculino" ? "contained" : "outlined"
                }
                onClick={() => setGenderFilter("masculino")}
              >
                Masculino
              </Button>
              <Button
                variant={
                  genderFilter === "feminino" ? "contained" : "outlined"
                }
                onClick={() => setGenderFilter("feminino")}
              >
                Feminino
              </Button>
            </Box>

            <Box
              sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>

              {account.id == 34 && (
                <BasicModal
                  chaves={dataTratada}
                  tournamentId={tournament.id}
                  tournamentName={tournament.name}
                  tournamentDate={tournament.date}
                  tournamentLocation={tournament.location}
                  tournamentRules={tournament.rules}
                />
              )}
            </Box>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 3,
              }}
            >
              TODAS AS LUTAS
            </Typography>
          </PageTitleContainer>

          <SubscriptionContainer>
            {subscription.map((item: any, catIndex: number) => {
              const filteredData = filterByGender(item.data);

              filteredData.sort((a: any, b: any) => {
                const nomeA = (
                  a.fighters ? a.fighters.name : a.user.name
                ).toLowerCase();
                const nomeB = (
                  b.fighters ? b.fighters.name : b.user.name
                ).toLowerCase();
                return nomeA.localeCompare(nomeB);
              });

              if (showData && filteredData.length > 0) {
                return (
                  <React.Fragment key={item.title}>
                    <br></br>
                    <PageTitle>{`${catIndex + 1}- ${item.title}`}</PageTitle>

                    {filteredData.map((value: any, index: number) => (
                      <SubscriptionList key={value.id}>
                        <SubscriptionItem
                          style={{
                            backgroundColor:
                              value.genre?.toLowerCase() === "feminino"
                                ? "#fee0f1"
                                : "#DBECF4",
                          }}
                        >
                          <SubscriptionContent>
                            <SubscriptionDescription>
                              <InfoContainerText>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ flexGrow: 1 }}>
                                    <span>
                                      <b>{index + 1}. (Nº {value.id}) </b>
                                      {(value.fighters
                                        ? value.fighters.name
                                        : value.user.name
                                      ).toLocaleUpperCase()}
                                      {" - " +
                                        value.belt?.toUpperCase() +
                                        " - " +
                                        value.weight?.split(";")[0] +
                                        " - " +
                                        value.age +
                                        " anos"}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexShrink: 0,
                                      textAlign: "right",
                                      alignContent: 'center',
                                      gap: 5
                                    }}
                                  >
                                    <span>
                                      {(value.fighters
                                        ? value.fighters.gym
                                        : value.user.gym
                                      ).toLocaleUpperCase()}{" "}
                                    </span>

                                    {(value.userId === account.id ||
                                      manager) && (
                                        <>
                                          <HistoryIcon
                                            color="action"
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => showHistorySubsModal(value.id)} />
                                            {' '}
                                          <EditIcon
                                            color="action"
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => handleEditFighter(value.id)} />

                                        </>
                                      )}
                                  </div>
                                </div>

                              </InfoContainerText>
                            </SubscriptionDescription>
                          </SubscriptionContent>
                        </SubscriptionItem>
                      </SubscriptionList>
                    ))}
                    <br></br> <br></br>
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </SubscriptionContainer>
        </Content>

        <Content id="semlutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter((item: any) => item.data.length === 1)
                  .length
              }{" "}
              CHAVES SEM LUTAS (TOTAL)
            </Typography>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter(
                  (item: any) => filterByGender(item.data).length === 1
                ).length
              }{" "}
              CHAVES SEM LUTAS (FILTRADAS)
            </Typography>

            <Box
              sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>
            </Box>
          </PageTitleContainer>

          <SubscriptionContainer>
            {subscription
              .filter((item: any) => filterByGender(item.data).length === 1)
              .map((item: any) => {
                const filteredData = filterByGender(item.data);

                filteredData.sort(
                  (a: { age: number }, b: { age: number }) => a.age - b.age
                );

                if (showData && filteredData.length > 0) {
                  return (
                    <React.Fragment key={item.title}>
                      <PageTitle>{item.title}</PageTitle>
                      {filteredData.map((value: any, index: number) => (
                        <SubscriptionList key={value.id}>
                          <SubscriptionItem
                            style={{
                              backgroundColor:
                                value.genre?.toLowerCase() === "feminino"
                                  ? "#fee0f1"
                                  : "#DBECF4",
                            }}
                          >
                            <SubscriptionContent>
                              <SubscriptionTitle>
                                Inscrição Nº {value.id} {(value.userId === account.id ||
                                    manager) && (
                                      <>
                                        <HistoryIcon
                                          color="action"
                                          sx={{ cursor: 'pointer' }}
                                          onClick={() => showHistorySubsModal(value.id)} />
                                          {' '}
                                        <EditIcon
                                          color="action"
                                          sx={{ cursor: 'pointer' }}
                                          onClick={() => handleEditFighter(value.id)} />

                                      </>
                                    )}
                              </SubscriptionTitle>
                              <SubscriptionDescription>
                                <InfoContainerText>
                                  <span>
                                    <b>Nome:</b>{" "}
                                    {value.fighters
                                      ? value.fighters.name
                                      : value.user.name}
                                  </span>
                                  <span>
                                    <b>Faixa: </b> {value.belt}
                                  </span>

                                  <span>
                                    <b>Idade de luta:</b>{" "}
                                    {value.age + " anos"}
                                  </span>

                                  <span>
                                    <b>Peso:</b> {value.weight.split(";")[0]}
                                  </span>

                                  <span>
                                    <b>Academia: </b>{" "}
                                    {value.fighters
                                      ? value.fighters.gym
                                      : value.user.gym}
                                  </span>



                                </InfoContainerText>
                              </SubscriptionDescription>
                            </SubscriptionContent>
                          </SubscriptionItem>
                        </SubscriptionList>
                      ))}
                    </React.Fragment>
                  );
                } else {
                  return null;
                }
              })}
          </SubscriptionContainer>
        </Content>

        <Content
          id="relatorioTorneio"
          style={{ alignContent: "left", justifyContent: "left" }}
        >
          {/* Campo de entrada para a senha */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "200px",
            }}
          >
            <FormContent onSubmit={handleSubmit(handleCheckPassword)}>
              <FormGroup>
                <Input
                  label="Senha"
                  name="password"
                  type="password"
                  register={register}
                  required
                  error="Este campo é obrigatório"
                  trim={true}
                />
              </FormGroup>
              <FormGroup>
                <Button type="submit">Entrar</Button>
              </FormGroup>
            </FormContent>
          </div>

          {isAuthorized && (
            <>
              <h1>Relatório de Inscrições</h1>
              <h2>{quantidadeInscrcaoPagas} Inscrições</h2>
              <h2>{quatidadeDeChaves} Total de Chaves</h2>
              <h2>{quatidadeDeChavesSemLuta} Chaves sem Luta</h2>
              <h2>
                {quatidadeDeChaves - quatidadeDeChavesSemLuta} Chaves com luta
              </h2>

              <h1>Relatório de Medalhas</h1>
              <h2>{medalhasOuro} Ouro</h2>
              <h2>{medalhasPrata} Prata</h2>
              <h2>{medalhasBronze} Bronze</h2>
              <hr />

              <h1> Todas as incrições</h1>

              <TournamentLink
                href={`/subscription/by-owner/${tournament.slug}`}
              >
                Ver Todas As Inscrições
              </TournamentLink>
              <TournamentLink href={`/reportDetail/tournament/${slug}`}>
                Relatório detalhado
              </TournamentLink>
            </>
          )}
        </Content>

        <HistoryModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          history={historyData}
          title="Inscrição"
          fieldLabels={{
            weight: 'Peso',
            category: 'Categoria',
            age: 'Idade',
            belt: 'Faixa',
          }}
          hiddenFields={
            [
              'tournamentId',
              'valueSubscription',
              'combo_subscription',
              'userId',
              'genre',
              'fightersId',
              'status',
              'tshirtId',
              'championGuarantee',
              'priceChampionGuarantee',
            ]
          }
        />

        <Zoom in={visible}>
          <Fab
            color="primary"
            size="medium"
            onClick={scrollToTop}
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              backgroundColor: "#373737",
              borderRadius: "50%",
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>
      </Container>
    </>
  );
};

export default AllCheckCategoriesICopaBjjTalentDeJiuJitsu2026;
